import Axios from "@/utils/axios/Axios";
import ENV from "@/utils/constants/environment";
import User from "@/model/User";
import Pagination from "@/model/Pagination";

const RESOURCE_NAME = "outlet";

export default {
  getAuthenticatedUser() {
    return Axios().get(ENV.API_URL + RESOURCE_NAME + `/authenticated`);
  },
  findAll(pagination: Pagination, params: any) {
    return Axios().get(ENV.API_URL + RESOURCE_NAME, {
      params: {
        page: pagination.page,
        size: pagination.size,
        sort: pagination.sort,
        search: params.search,
        active: params.active
      }
    });
  },
  findById(id: number) {
    return Axios().get(ENV.API_URL + RESOURCE_NAME + `/${id}`);
  },
  saveUser(user: User) {
    return Axios().post(ENV.API_URL + RESOURCE_NAME, user);
  },
  updateUser(user: User) {
    return Axios().put(ENV.API_URL + RESOURCE_NAME + `/${user.id}`, user);
  },
  deleteUser(id: number) {
    return Axios().delete(ENV.API_URL + RESOURCE_NAME + `/${id}`);
  },
  rememberPassword(email: string) {
    return Axios().post(ENV.BASE_URL + "/remember-password", null, {
      params: {
        email
      },
      transformRequest: [
        (data: any, headers: { Authorization: any }) => {
          delete headers?.Authorization;
          return data;
        }
      ]
    });
  },
  adminPassword(password: any) {
    return Axios().post("/outlet/admin-password", null, password);
  }
};
